var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 494,
    height: 282,
    viewBox: "0 0 494 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.85 0L95.34 23.29L125.04 13.91L109.04 40.44L127.21 65.55L96.83 58.66L78.36 83.56L75.58 52.77L46 43.05L74.66 30.91L74.85 0Z",
    fill: "url(#paint0_linear_13276_10445)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M482.95 68L481.54 81.46L493.44 88.1L480.09 90.94L477.41 104.22L470.56 92.5L457 94.07L466.12 83.99L460.43 71.68L472.91 77.17L482.95 68Z",
    fill: "url(#paint1_linear_13276_10445)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M406.99 0L404.99 19.2L421.96 28.67L402.93 32.72L399.09 51.64L389.33 34.94L370 37.17L383 22.8L374.88 5.26L392.68 13.08L406.99 0Z",
    fill: "url(#paint2_linear_13276_10445)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.18 173.83L17.83 179.06L29.3 166L29.43 183.32L45.5 190.1L28.93 195.58L27.39 212.84L17.02 198.89L0 202.78L10.16 188.69L1.18 173.83Z",
    fill: "url(#paint3_linear_13276_10445)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147 271.78L156.59 259.57L149.11 245.98L163.78 251.26L174.5 240L173.98 255.48L188.08 262.11L173.08 266.4L171.08 281.75L162.34 268.93L147 271.78Z",
    fill: "url(#paint4_linear_13276_10445)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13276_10445",
    x1: 63.6975,
    y1: 29.0613,
    x2: 115.793,
    y2: 55.9879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9B938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13276_10445",
    x1: 470.222,
    y1: 73.1535,
    x2: 477.1,
    y2: 97.7447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9B938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13276_10445",
    x1: 388.839,
    y1: 7.347,
    x2: 398.656,
    y2: 42.4063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9B938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13276_10445",
    x1: 4.37948,
    y1: 191.084,
    x2: 37.197,
    y2: 188.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9B938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13276_10445",
    x1: 162.55,
    y1: 274.49,
    x2: 170.777,
    y2: 246.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9B938"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.02575c98.svg";
export { ForwardRef as ReactComponent };